import React, { useEffect, useRef, useState } from "react";
import { ArrowUp, Edit, Plus } from "react-feather";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { templateActions } from "../../../store/master/template-slice";
import Grid from "../../Grid";
import Button from "../../input/Button";
import Input from "../../input/Input";
import ButtonRenderer from "../../renderer/ButtonRenderer";
import RadioCheckboxRenderer from "../../renderer/RadioCheckboxRenderer";
import { dynamicDropdownValuesCreationValidation } from "../../validations/DynamicTemplateHeader";

const TemplateDropdown = ({
  fieldData,
  setFieldData,
  closeModal,
  setProceedReset,
  flag,
  setFlag,
  editMode,
  isEditModeDataLoading,
  addModeInModal,
  setAddModeInModal,
  fieldSeq,
  setFieldSeq,
  dropdownValue,
  setDropdownValue,
  setAddMode,
}) => {
  const user = useSelector((state) => state.user);
  const fieldCount = useSelector((state) => state.template.fieldCount);
  const dispatch = useDispatch();
  const [dropdownAddLoading, setDropdownAddLoading] = useState(false);
  const [deletedDropdownList, setDeletedDropdownList] = useState([]);
  const [isSettingDropdownValues, setIsSettingDropdownValues] = useState(false);
  const [dropdownValueCount, setDropdownValueCount] = useState(1);
  const gridDropdownRef = useRef();
  const [currentErrors, setCurrentErrors] = useState({});

  useEffect(() => {
    if (editMode) {
      setDropdownValueCount(fieldData?.dropdownValues?.length + 1);
    }
  }, [editMode, fieldData]);

  const onDropdownAddClick = () => {
    setDropdownAddLoading(true);
    console.log("Field Data in modal", fieldData);

    //cant be added empty(default value) rows to the grid
    const dropdownErrors = dynamicDropdownValuesCreationValidation({
      dydValue: dropdownValue.dydValue,
      dydDescription: dropdownValue.dydDescription,
    });

    if (Object.keys(dropdownErrors).length > 0) {
      setCurrentErrors(dropdownErrors);
      setDropdownAddLoading(false);
      toast.error("Please fill all the required fields",{ autoClose: 5000, containerId: "Modal" });
      return;
    }

    if (addModeInModal) {
      if (
        fieldData.dropdownValues?.some(
          (item) => item.dydValue === dropdownValue.dydValue
        )
      ) {
        setDropdownAddLoading(false);
        toast.error("Duplicate value is not allowed");
        return;
      }
    }

    setCurrentErrors({});

    if (dropdownValue.dydId === null) {
      if (dropdownValue.id === null) {
        console.log("In first if");
        setFieldData((prevData) => ({
          ...prevData,
          // id: fieldCount,
          dropdownValues: [
            ...prevData.dropdownValues,
            {
              ...dropdownValue,
              dydSeq: prevData.currentDropdownSeq,
              id: dropdownValueCount,
              created: true,
            },
          ],
          dropdownCount: dropdownValueCount,
          currentDropdownSeq: prevData.currentDropdownSeq + 1,
        }));
        // dispatch(templateActions.incrementFieldCount());
        setDropdownValueCount((prevCount) => ++prevCount);
      } else {
        console.log("In first else");
        setFieldData((prevData) => ({
          ...prevData,
          dropdownValues: [
            ...prevData.dropdownValues.map((item) => {
              if (item.id === dropdownValue.id) {
                return {
                  ...dropdownValue,
                  created: true,
                };
              }

              return item;
            }),
          ],
        }));
      }
    } else {
      console.log("In second else");
      setFieldData((prevData) => ({
        ...prevData,
        dropdownValues: [
          ...prevData.dropdownValues?.map((item) => {
            if (item.dydId === dropdownValue.dydId) {
              return {
                ...dropdownValue,
                dydSeq: item.dydSeq,
                modified: true,
              };
            }

            return item;
          }),
        ],
      }));
    }

    setDropdownAddLoading(false);
    setAddModeInModal(true);

    setDropdownValue({
      id: null,
      dydId: null,
      dydReferance: "",
      dydCompany: 1,
      dydDyfId: null,
      dydValue: "",
      dydUom: null,
      dydDescription: "",
      dydRequired: false,
      dydSeq: 1,
      dydStatus: 2,
      dydActive: 1,
      default: false,
      author: user.username,
    });
  };

  const addDropdownValuesToRedux = () => {
    setIsSettingDropdownValues(true);

    if (fieldData.dropdownValues?.length < 2) {
      toast.error("Please add at least two dropdown values.", { autoClose: 5000, containerId: "Modal" });
      setIsSettingDropdownValues(false);
      return;
    }

    const defaultValue = fieldData.dropdownValues?.find(
      (item) => item.default === true
    );

    if (!fieldData.dyfId || fieldData.dyfId === null) {
      if (!flag) {
        let seqId = fieldSeq + 1;
        console.log("Not in flag");
        dispatch(
          templateActions.addToFieldList({
            ...fieldData,
            id: fieldCount,
            dyfSeq: seqId,
            dropdownDefaultValueName: defaultValue ? defaultValue.dydValue : "",
            dyfDefaultValue: defaultValue ? defaultValue.dydSeq.toString() : "",
          })
        );
        setFieldSeq(seqId);
        dispatch(templateActions.incrementFieldCount());
      } else {
        console.log("In flag");
        dispatch(
          templateActions.updateFieldList({
            ...fieldData,
            dropdownDefaultValueName: defaultValue ? defaultValue.dydValue : "",
            dyfDefaultValue: defaultValue ? defaultValue.dydSeq.toString() : "",
          })
        );
        setFlag(false);
      }
    } else {
      console.log("In else");
      dispatch(
        templateActions.updatePersistedFieldList({
          ...fieldData,
          dropdownDefaultValueName: defaultValue ? defaultValue.dydValue : "",
          dyfDefaultValue: defaultValue ? defaultValue.dydSeq.toString() : "",
        })
      );
    }
    
    setAddMode(true);
    setAddModeInModal(true);
    closeModal();
    setProceedReset(true);
    setIsSettingDropdownValues(false);
  };

  return (
    <div className="ui form segment">
      <h4 className="ui dividing header">
        Add Dropdown Values for{" " + fieldData.dyfField}
      </h4>
      <div className="two fields">
        <Input
          required={true}
          label="Dropdown Value"
          type="text"
          name="dropdownValue"
          value={dropdownValue.dydValue}
          onChange={(e) => {
            setDropdownValue({
              ...dropdownValue,
              dydValue: e.target.value,
            });
          }}
          error={currentErrors.dydValue}
          resetError={() =>
            setCurrentErrors((prevState) => {
              const { dydValue: _, ...rest } = prevState;
              return rest;
            })
          }
        />
        <Input
          required={true}
          label="Description"
          type="text"
          name="dropdownDescription"
          value={dropdownValue.dydDescription}
          onChange={(e) => {
            setDropdownValue({
              ...dropdownValue,
              dydDescription: e.target.value,
            });
          }}
          error={currentErrors.dydDescription}
          resetError={() =>
            setCurrentErrors((prevState) => {
              const { dydDescription: _, ...rest } = prevState;
              return rest;
            })
          }
        />
        <Input
          label="Reference"
          type="text"
          name="dropdownReference"
          value={dropdownValue.dydReferance}
          onChange={(e) => {
            setDropdownValue({
              ...dropdownValue,
              dydReferance: e.target.value,
            });
          }}
          error={currentErrors.dydReferance}
          resetError={() =>
            setCurrentErrors((prevState) => {
              const { dydReferance: _, ...rest } = prevState;
              return rest;
            })
          }
        />
      </div>
      <div
        style={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
        }}
      >
        <div className="field" style={{ width: "100%" }}>
          <Button
            label={!addModeInModal ? "Update" : "Add"}
            Icon={!addModeInModal ? Edit : Plus}
            editMode={editMode}
            onClick={onDropdownAddClick}
            isLoading={dropdownAddLoading}
          />
        </div>
      </div>
      <Grid
        searchable={false}
        ref={gridDropdownRef}
        heading="Dropdown Values List"
        isLoading={isEditModeDataLoading}
        config={[
          {
            headerName: "Default Value",
            field: "default",
            cellRenderer: RadioCheckboxRenderer,
            cellRendererParams: (params) => ({
              onChangeHandler: (e) => {
                setFieldData((prevData) => ({
                  ...prevData,
                  dropdownValues: [
                    ...prevData.dropdownValues?.map((item) => {
                      if (item.default) {
                        return {
                          ...item,
                          default: false,
                        };
                      }

                      if (item.dydSeq === params.data.dydSeq) {
                        return {
                          ...item,
                          default: !item.default,
                        };
                      }

                      return item;
                    }),
                  ],
                }));
              },
            }),
            editable: true,
          },
          { headerName: "Dropdown Value", field: "dydValue" },
          { headerName: "Description", field: "dydDescription" },
          { headerName: "Reference", field: "dydReferance" },
          {
            field: "Edit",
            filter: true,
            cellRenderer: ButtonRenderer,
            cellRendererParams: (params) => ({
              clickHandler: () => {
                setAddModeInModal(false);
                setDropdownValue({
                  id: params.data.id,
                  dydId: params.data.dydId,
                  dydReferance: params.data.dydReferance,
                  dydCompany: params.data.dydCompany,
                  dydDyfId: params.data.dydDyfId,
                  dydValue: params.data.dydValue,
                  dydUom: params.data.dydUom,
                  dydDescription: params.data.dydDescription,
                  dydRequired: params.data.dydRequired,
                  dydSeq: params.data.dydSeq,
                  dydStatus: params.data.dydStatus,
                  dydActive: params.data.dydActive,
                  default: params.data.default,
                });
              },
              label: "Edit",
              className: "ui secondary button",
            }),
          },
          {
            field: "Delete",
            filter: true,
            cellRenderer: ButtonRenderer,
            cellRendererParams: (params) => ({
              clickHandler: async () => {
                const currentSeqValue = params.data.dydSeq;
                const currentId = params.data.id;

                setFieldData((prevData) => ({
                  ...prevData,
                  dropdownValues: [
                    ...prevData.dropdownValues?.filter(
                      (item) => item.id !== params.data.id
                    ),
                  ],
                }));

                setFieldData((prevData) => ({
                  ...prevData,
                  dropdownValues: [
                    ...prevData.dropdownValues?.map((item) => {
                      if (item.dydSeq > currentSeqValue) {
                        return {
                          ...item,
                          dydSeq: item.dydSeq - 1,
                        };
                      }

                      return item;
                    }),
                  ],
                }));

                setFieldData((prevData) => ({
                  ...prevData,
                  dropdownValues: [
                    ...prevData.dropdownValues?.map((item) => {
                      if (item.id > currentId) {
                        return {
                          ...item,
                          id: item.id - 1,
                        };
                      }
                      return item;
                    }),
                  ],
                }));

                setFieldData((prevData) => ({
                  ...prevData,
                  currentDropdownSeq: prevData.dropdownValues?.length + 1,
                }));
              },
              label: "Delete",
              className: "ui red button",
            }),
          },
        ]}
        content={fieldData.dropdownValues}
      />
      <div
        style={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
          padding: "5px 0",
        }}
      >
        <div className="field" style={{ width: "100%" }}>
          <Button
            Icon={ArrowUp}
            label={"Set to Field"}
            onClick={addDropdownValuesToRedux}
            loading={isSettingDropdownValues}
          />
        </div>
      </div>
    </div>
  );
};

export default TemplateDropdown;
